module.exports = __webpack_public_path__ + "img/K인플레이아이콘.f2672204.jpg";